exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".manageRatingsPage__link___cBnrt {\n  color: blue; }\n", ""]);

// exports
exports.locals = {
	"link": "manageRatingsPage__link___cBnrt"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/routes/Admin/ManageRatingsPage/manageRatingsPage.scss
// module id = 4043
// module chunks = 6